import React from 'react';
import { cn } from '../../../lib';

export interface HeroBannerSkeletonProps {
  className?: string;
  isCentered?: boolean;
}

export const HeroBannerSkeleton = ({ className = '', isCentered = false }: HeroBannerSkeletonProps) => {
  // Medium size padding (removed variants, using medium only)
  const paddingClass = isCentered
    ? 'px-[20px] md:px-[64px] md:pt-[64px] md:pb-[64px]'
    : 'md:px-[96.5px] md:pl-[120px] px-[20px] py-[64px]';
  const layoutClass = isCentered ? 'flex flex-col items-center text-center' : '';

  return (
    <div className="relative w-full bg-secondary-50">
      <div className={cn(paddingClass, layoutClass, className, 'relative z-[1]')}>
        {/* Tag skeleton */}
        <div className="bg-secondary-100 rounded-md px-[16px] py-[8px] inline-block">
          <div className="w-20 h-4 skeleton-item rounded skeleton-stagger-1"></div>
        </div>

        {/* Heading skeleton */}
        <div className="mt-[32px]">
          <div className="w-full max-w-md h-16 skeleton-item rounded skeleton-stagger-2"></div>
        </div>

        {/* Quote skeleton */}
        <div className="mt-[32px] space-y-2">
          <div className="w-full max-w-lg h-4 skeleton-item rounded skeleton-stagger-3"></div>
          <div className="w-3/4 h-4 skeleton-item rounded skeleton-stagger-4"></div>
        </div>

        {/* Buttons skeleton */}
        <div className={cn('mt-[32px] flex flex-wrap gap-[16px]', isCentered && 'justify-center')}>
          <div className="w-32 h-10 skeleton-item rounded skeleton-stagger-5"></div>
          <div className="w-28 h-10 skeleton-item rounded skeleton-stagger-6"></div>
        </div>

        {/* Social links skeleton */}
        <div className={cn('mt-[32px]', isCentered && 'mx-auto')}>
          <div className="flex gap-4">
            {[1, 2, 3, 4].map((i) => (
              <div key={i} className={`w-8 h-8 skeleton-item rounded-full skeleton-stagger-${i + 6}`}></div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
